<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="app-container member-center">
        <div v-loading="loading">
          <div class="member-header" v-if="memberInfo.id">
            <div class="avatar-wrap">
              <img :src="memberInfo.avatar || require('@/assets/image/avatar/0.png')" class="avatar" alt="avatar" />
            </div>
            <div class="member-basic">
              <div class="username">{{ memberInfo.username }}</div>
              <div class="level-row">
                <span class="lv-badge">{{ memberInfo.memberLevelName || 'LV1' }}</span>
                <span class="vip-badge" v-if="memberInfo.vipLevelName">{{ memberInfo.vipLevelName }}</span>
                <span class="vip-expire" v-if="memberInfo.vipExpireDate">{{ $t('message.home.expiry') }}: {{ memberInfo.vipExpireDate }}</span>
              </div>
              <div class="growth-bar" v-if="memberInfo.growthValue !== undefined">
                <span class="growth-label">{{ $t('message.home.growthValue') }}: {{ memberInfo.growthValue }}</span>
              </div>
              <div class="point-row">
                <span class="point-icon">⭐</span>
                <span class="point-val">{{ memberInfo.point || 0 }} {{ $t('message.home.points') }}</span>
              </div>
            </div>
          </div>

          <div class="section-title">{{ $t('message.home.vipPrivileges') }}</div>
          <div class="vip-level-list" v-if="vipLevels.length">
            <div class="vip-card" v-for="vip in vipLevels" :key="vip.id" :class="{ current: memberInfo.vipLevelId === vip.id }">
              <div class="vip-name">{{ vip.name }}</div>
              <div class="vip-price">¥{{ vip.price }} / {{ vip.periodInDays }}{{ $t('message.home.days') }}</div>
              <div class="vip-rights">
                <div v-for="right in (vip.rights || [])" :key="right.id" class="right-item">✓ {{ right.rightName }}</div>
              </div>
              <el-button type="primary" size="small" class="buy-btn" @click="toBuy(vip)">
                {{ memberInfo.vipLevelId === vip.id ? $t('message.home.renew') : $t('message.home.subscribe') }}
              </el-button>
            </div>
          </div>
          <el-empty v-if="!vipLevels.length && !loading" :description="$t('message.home.noData')" />
        </div>
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import { getMemberCenter, listVipLevel } from "@/api/upms/member_center";

export default {
  name: "MemberCenter",
  data() {
    return { loading: false, memberInfo: {}, vipLevels: [] }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      Promise.all([getMemberCenter(), listVipLevel()]).then(([r1, r2]) => {
        this.memberInfo = r1.data?.data || {}
        this.vipLevels = r2.data?.data || []
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    toBuy(vip) { this.$router.push({ path: '/member/buy', query: { vipId: vip.id } }) },
  }
}
</script>

<style lang="scss" scoped>
.container-box { background: #f5f5f5; min-height: calc(100vh - 120px); }
.app-container { width: 1200px; margin: 0 auto; padding: 30px 0; }
.member-header { background: #fff; border-radius: 8px; padding: 30px; display: flex; align-items: center; margin-bottom: 20px; }
.avatar { width: 80px; height: 80px; border-radius: 50%; }
.member-basic { margin-left: 24px; }
.username { font-size: 20px; font-weight: bold; margin-bottom: 8px; }
.level-row { display: flex; align-items: center; gap: 10px; margin-bottom: 8px; }
.lv-badge { background: #e6f0ff; color: #409eff; padding: 2px 10px; border-radius: 12px; font-size: 13px; }
.vip-badge { background: #fff4e6; color: #e6a23c; padding: 2px 10px; border-radius: 12px; font-size: 13px; }
.vip-expire, .growth-label { font-size: 13px; color: #909399; }
.point-row { font-size: 14px; color: #606266; }
.section-title { font-size: 18px; font-weight: bold; margin-bottom: 16px; }
.vip-level-list { display: flex; gap: 16px; flex-wrap: wrap; }
.vip-card { background: #fff; border-radius: 8px; padding: 24px; width: 260px; border: 2px solid #eee; }
.vip-card.current { border-color: #e6a23c; }
.vip-name { font-size: 18px; font-weight: bold; color: #303133; margin-bottom: 8px; }
.vip-price { font-size: 22px; color: #e6a23c; font-weight: bold; margin-bottom: 12px; }
.right-item { font-size: 13px; color: #606266; margin-bottom: 4px; }
.buy-btn { width: 100%; margin-top: 16px; }
</style>
